/**
 * DESIGNER_NAV — the designer portal's navigation registry.
 */
import { Palette } from "lucide-react";
import type { PortalNavItem } from "@/components/navigation/PortalSidebar";

export const DESIGNER_NAV: PortalNavItem[] = [
  {
    key: "work",
    path: "/designer/work",
    label: "Design Work",
    icon: Palette,
    iconClass: "text-icon-designer",
  },
];
